import { DatasetLoadingConf } from "components/dashboard/charts/interfaces";
import { IDateRange } from "components/dashboard/product-template-table/utils/interfaces";
import { T } from "services/lang/LanguageService";

export interface IProductTemplateBarChart extends IDateRange {
  referenceTime: string | undefined;
  id: number;
  safeName: string;
  loadConf: DatasetLoadingConf;
  nameColumn: string;
  timeColumn: string;
  valueColumn: string;
  valueUnit: string;
  aggregationType: string;
  height?: number;
  width?: number;
  filter?: string;
  decimalPlaces?: number;
}

export enum AggregationOption {
  SUM = "SUM",
  AVG = "AVG",
  MIN = "MIN",
  MAX = "MAX",
  COUNT = "COUNT",
}

export const aggregationOptions = [
  { label: T("word.sum"), value: AggregationOption.SUM },
  { label: T("word.average"), value: AggregationOption.AVG },
  { label: T("word.min"), value: AggregationOption.MIN },
  { label: T("word.max"), value: AggregationOption.MAX },
  { label: T("action.count"), value: AggregationOption.COUNT },
];
